module.exports = __webpack_public_path__ + "static/media/mmoga.02d42d21.png";